// extracted by mini-css-extract-plugin
export var modalFooter = "_or-0";